var exports = {
  "a": "PollAnswerInput.module__deleteAnswerButton___OEZkSk",
  "J": "PollAnswerInput.module__emojiValueButton___OEZkSk",
};

module.exports = exports;
